import { ChartDatapoint } from '../../../common/Chart/Chart';
import { MaxMetricTotalStrategy } from '../../../common/metrics/metric-definitions';

type MaxMetricDataset = {
  data: ChartDatapoint[];
  highest: number;
};

const getLatestFiniteValue = ({ data }: MaxMetricDataset): number => {
  for (let index = data.length - 1; index >= 0; index--) {
    const value = Number(data[index].y);
    if (Number.isFinite(value)) {
      return value;
    }
  }

  return Number.NaN;
};

export const getMaxMetricTotal = (
  datasets: MaxMetricDataset[],
  strategy: MaxMetricTotalStrategy,
): number | undefined => {
  if (strategy === 'sum_highest_when_multiple' && datasets.length > 1) {
    return datasets.reduce((total, dataset) => total + dataset.highest, 0);
  }

  const latest_values = datasets.map(getLatestFiniteValue).filter(Number.isFinite);
  if (latest_values.length === 0) {
    return undefined;
  }

  if (strategy === 'sum_latest') {
    return latest_values.reduce((total, value) => total + value, 0);
  }

  return Math.max(...latest_values);
};
